import React from 'react';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';

interface StripeCheckoutLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'outline';
}

export const StripeCheckoutLink: React.FC<StripeCheckoutLinkProps> = ({
  href,
  children,
  className,
  variant = 'primary',
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={clsx(
      'inline-flex items-center justify-center gap-2 font-semibold transition-colors',
      variant === 'primary' &&
        'rounded-lg bg-slate-900 px-4 py-2.5 text-sm text-white hover:bg-slate-800',
      variant === 'outline' &&
        'rounded-lg border border-slate-300 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50',
      className
    )}
  >
    <CreditCardIcon className="h-4 w-4 shrink-0" aria-hidden />
    {children}
  </a>
);

export default StripeCheckoutLink;
